<script>
	import Layout from '../components/Layout.svelte';

	export let ID;
</script>

<Layout {ID}>
	<slot />
</Layout>
